import Choices from 'choices';

class Choice {
	constructor( node, opts = {} ) {
		this.node = typeof node === 'string' ? document.querySelector( node ) : node;

		if ( ! this.node ) {
			return;
		}

		this.opts = Object.assign( {
			onChange: () => {},
			choices: {},
		}, opts );

		this.opts.choices = Object.assign( {
			itemSelectText: '',
			searchEnabled: true,
			searchResultLimit: 100,
			shouldSort: false,
		}, opts.choices || {} );

		this.choice = new Choices( this.node, this.opts.choices );

		this.onChange = () => {
			this.opts.onChange( this.choice.getValue( true ) );
		};

		this.listen();
	}

	setValue( value = '' ) {
		this.choice.setChoiceByValue( value || '' );
	}

	setOptions( value, name = 'name', label = 'label' ) {
		if ( typeof this.opts.formatOption === 'function' ) {
			value = value.map( this.opts.formatOption );
		}

		let all = {};
		all[ name ] = '';
		all[ label ] = `All ${this.node.dataset.label}` || 'All';
		value.unshift( all );

		this.choice.setChoices( value, name, label, true );
	}

	listen() {
		this.node.addEventListener( 'change', this.onChange );
	}

	unlisten() {
		this.node.removeEventListener( 'change', this.onChange );
	}
}

export default Choice;
